import { render, staticRenderFns } from "./ProcessLoading.vue?vue&type=template&id=8455f2f6&scoped=true"
import script from "./ProcessLoading.vue?vue&type=script&lang=js"
export * from "./ProcessLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8455f2f6",
  null
  
)

export default component.exports